import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarService } from '../navbar/navbar.service';
import { ProfileService } from '../auth/profile.service';
import { SESSION_STORAGE_KEY } from 'src/app/const/session-storage-key';

@Component({
    templateUrl: './page-not-found.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class PageNotFoundComponent implements OnInit {

  private readonly translationIndex = 'pageNotFound';
  message: any;
  goHomeUrl: string;

  constructor(private readonly pfs: ProfileService, private readonly navbar: NavbarService) { }

  ngOnInit() {
    sessionStorage.removeItem(SESSION_STORAGE_KEY.adminUIPath);
    this.message = this.pfs.messages[this.translationIndex];
    this.goHomeUrl = this.navbar.getProfileDefaultPath(this.pfs.profile);
  }

}
